import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoutes from "./utils/PrivateRoutes";
import { AuthProvider } from "./context/AuthContext";
import Home from './components/Home/Home.jsx'
import EditInventory from "./components/Inventory/EditInventory";
import ManageInventory from "./components/Inventory/ManageInventory";
import SearchInventory from "./components/Inventory/SearchInventory";
import Drivers from './components/Drivers/Drivers.jsx'
import UsersList from './components/Users/UsersList'
import { Layout } from "antd";
import Locations from "./components/Locations/Locations";
import AddLocation from "./components/Locations/AddLocation";
import AddInventory from "./components/Inventory/AddInventory";
import Signup from "./components/Users/Signup";
import NotFoundPage from "./components/NotFoundPage";
import ViewLocation from "./components/Locations/ViewLocation";
import AdminRoutes from "./utils/AdminRoutes";
import Profile from "./components/Users/Profile";
import AdminEditUser from "./components/Users/AdminEditUser";
import InventorySummary from "./components/Inventory/InventorySummary.jsx";
import InventoryCityList from "./components/Inventory/InventoryCityList";
import Leads from "./components/Leads/Leads";
import AddLead from "./components/Leads/AddLead";
import LeadDetails from "./components/Leads/LeadDetails";
import LeadsFromHubspot from "./components/Leads/LeadsFromHubspot";
import TodosList from "./components/Todos/TodosList";
import DeliveryDetails from "./components/Home/DeliveryDetails.jsx";
import ManagePrices from "./components/Inventory/ManagePrices.jsx";
import Login from "./components/Users/Login.jsx";
import AddDriver from "./components/Drivers/AddDriver.jsx";
import DriverDetails from "./components/Drivers/DriverDetails.jsx";
import SolidboxLayout from "./components/SolidboxLayout.jsx";
import { Helmet } from "react-helmet";

function LayoutWrapper() {

  return (
    <SolidboxLayout>
      <Helmet>
        <title>{"Portal"}</title>
        <link
          rel="icon"
          type="image/x-icon"
          href="/images/sbc-favicon.png"
        />
      </Helmet>

      <Routes>
        {/* shared route for home */}
        <Route path="/" element={<Home />} />

        {/* solidbox */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup isSolidbox={true} />} />
        <Route path="/inventory" element={<InventorySummary />} />
        <Route path="/inventory/search" element={<SearchInventory />} />
        <Route path="/delivery-details" element={<DeliveryDetails />} />

        <Route element={<PrivateRoutes/>}>
          <Route
            path="/inventory/city/:city"
            element={<InventoryCityList />}
          />
          <Route path="/locations" element={<Locations />} />
          <Route path="/locations/:id" element={<ViewLocation />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/leads/:id" element={<LeadDetails />} />
          <Route path="/add-lead" element={<AddLead />} />
          <Route path="/tasks" element={<TodosList />} />
          <Route path="/manage-prices" element={<ManagePrices />} />
        </Route>

        <Route element={<AdminRoutes />}>
          <Route path="/add-inventory" element={<AddInventory />} />
          <Route path="/inventory/:id" element={<EditInventory />} />
          <Route path="/manage-inventory" element={<ManageInventory />} />
          <Route path="/drivers" element={<Drivers />} />
          <Route path="/driver/:id" element={<DriverDetails />} />
          <Route path="/add-driver" element={<AddDriver />} />
          <Route path="/admin/users" element={<UsersList />} />
          <Route path="/admin/users/:id" element={<AdminEditUser />} />
          <Route path="/add-location" element={<AddLocation />} />·{" "}
          <Route path="/admin/leads-hubspot" element={<LeadsFromHubspot />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />

      </Routes>
    </SolidboxLayout>
  );
}

function App() {
  return (
    <Router>
    <div>
      <Layout style={{ height: "100vh" }}>
          <AuthProvider>
            <LayoutWrapper />
          </AuthProvider>
      </Layout>
    </div>
    </Router>
  );
}

export default App;
